module.exports = __webpack_public_path__ + "static/media/dancing.a8791da6.jpg";